import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { SocialProofBar } from '../components/SocialProofBar';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { PortfolioSection } from '../components/PortfolioSection';
import { GoogleProfilesSection } from '../components/GoogleProfilesSection';
import { PricingSection } from '../components/PricingSection';
import { ProcessSection } from '../components/ProcessSection';
import { StorySection } from '../components/StorySection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { FinalCTA } from '../components/FinalCTA';
import { FAQSection } from '../components/FAQSection';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
import { PromoPopup } from '../components/PromoPopup';
import { LeadFormModal } from '../components/LeadFormModal';
export function Home() {
  return <div className="min-h-screen bg-dark text-white font-sans selection:bg-gold selection:text-dark" data-id="element-580" data-mp="2qxak818svnkm">
      <Navbar data-id="element-581" data-mp="2mw8nbr2cvnlt" />
      <main data-id="element-582" data-mp="2mwqql7nfr238">
        <Hero data-id="element-583" data-mp="2mzcw71qrn7it" />
        <SocialProofBar data-id="element-584" data-mp="2hxxar8koeyzw" />
        <ProblemSection data-id="element-585" data-mp="2hy70cv1t7452" />
        <MechanismSection data-id="element-586" data-mp="2hzi4wx32wfx8" />
        <PortfolioSection data-id="element-587" data-mp="2hzqiysaxtra0" />
        <GoogleProfilesSection data-id="element-588" data-mp="2d7gttehncv8s" />
        <PricingSection data-id="element-589" data-mp="2d6f9ejeqqwee" />
        <ProcessSection data-id="element-590" data-mp="2d545mjlapona" />
        <StorySection data-id="element-591" data-mp="288414d43gtya" />
        <TestimonialsSection data-id="element-592" data-mp="287cfnv47oclq" />
        <GuaranteeSection data-id="element-593" data-mp="288ngpn69v695" />
        <UrgencySection data-id="element-594" data-mp="285rjk1290llr" />
        <FinalCTA data-id="element-595" data-mp="239ja94aqfmmi" />
        <ContactForm data-id="element-596" data-mp="23a2h9pyugqlr" />
        <FAQSection data-id="element-597" data-mp="23am1xefvpt3h" />
      </main>
      <Footer data-id="element-598" data-mp="1z7fwua4i67yl" />
      <FloatingWhatsApp data-id="element-599" data-mp="1z764wgzwdqq9" />
      <PromoPopup data-id="element-600" data-mp="1z6ea38e4jx11" />
      <LeadFormModal data-id="element-601" data-mp="1z6wewteurjkk" />
    </div>;
}